module.exports = __webpack_public_path__ + "static/media/logo-dark.8468269d.svg";